import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const BookingForm = ({ 
  checkInDate, 
  checkOutDate, 
  rooms, 
  handleSearch, 
  setCheckInDate, 
  setCheckOutDate, 
  incrementCount, 
  decrementCount, 
  addRoom, 
  deleteRoom 
}) => {
  const [popupVisible, setPopupVisible] = useState(false);

  return (
    <form>
      <Card className="p-4" style={{ marginTop: '43px' }}>
        <h4>Book This Now</h4>

        {/* Check-in Date */}
        <div className="search-body mb-3">
          <label htmlFor="checkin"><h6>Check In</h6></label>
          <DatePicker
            id="checkin"
            selected={checkInDate}
            onChange={(date) => setCheckInDate(date)}
            placeholderText="Select Check-in Date"
            className="form-control"
            dateFormat="dd/MM/yyyy"
            required
          />
        </div>

         {/* Check-out Date */}
        <div className="search-body mb-3">
          <label htmlFor="checkout"><h6>Check Out</h6></label>
          <DatePicker
            id="checkout"
            selected={checkOutDate}
            onChange={(date) => setCheckOutDate(date)}
            placeholderText="Select Check-out Date"
            className="form-control"
            dateFormat="dd/MM/yyyy"
            minDate={checkInDate ? new Date(checkInDate.getTime() + 86400000) : null}
            required
          />
        </div>

        {/* Rooms & Guests Picker */}
        <div
          className="search-body mb-3"
          onClick={() => setPopupVisible(true)}
          style={{ cursor: "pointer" }}
        >
          <label><h6>Rooms & Guests</h6></label>
          <div className="form-control">
            {`${rooms.length} Room${rooms.length > 1 ? 's' : ''}, ${rooms.reduce((total, room) => total + room.count, 0)} Guest${rooms.reduce((total, room) => total + room.count, 0) > 1 ? 's' : ''}`}
          </div>
        </div>

        {/* Room & Guest Popup */}
        {popupVisible && (
          <div className="popup">
            <div className="popup-content">
              <div className="room-control">
                <h6>Rooms</h6>
                <h6>Guests</h6>
              </div>
              <hr />
              {rooms.map((room, index) => (
                <div key={room.id} className="room-control">
                  <span>Room {index + 1}</span>
                  <button 
                    onClick={() => decrementCount(room.id)}
                    className="btn btn-sm btn-outline-secondary"
                    type="button"
                  >-</button>
                  <span className="mx-2">{room.count}</span>
                  <button 
                    onClick={() => incrementCount(room.id)}
                    className="btn btn-sm btn-outline-secondary"
                    type="button"
                  >+</button>
                </div>
              ))}
              <hr />
              <div className="room-control">
                <div className="col-md-6 col-xs-6 text-center">
                  <button 
                    onClick={deleteRoom} 
                    className="btn btn-link text-danger p-0"
                    type="button"
                  >
                    Delete Room
                  </button>
                </div>
                <div className="col-md-6 col-xs-6 text-center">
                  <button 
                    onClick={addRoom} 
                    className="btn btn-link text-primary p-0"
                    type="button"
                  >
                    Add Room
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Submit */}
        <Button onClick={handleSearch} variant="primary" className="w-100 mt-3">
          Book Now
        </Button>
      </Card>
    </form>
  );
};

export default BookingForm;
